import { normalisePlainText } from "./normalise-plain-text.mjs"

export function toComparableTask(task) {
    return {
        title: normalisePlainText(task?.title) || null,
        content: task?.content ?? null,
        note: task?.note ?? null,
        classification: task?.classification ?? null,
        minutes: task?.minutes ?? null,
        skillSet: task?.skillSet ?? null,
        unitOfMeasure: task?.unitOfMeasure ?? null,
        frequency: normaliseFrequency(task?.frequency),
    }
}

function normaliseFrequency(frequency = {}) {
    return {
        period: frequency?.period ?? null,
        interval: frequency?.interval ?? null,
    }
}
